import { createSlice } from '@reduxjs/toolkit';
import { getAllCarDelivery } from '../api/carDelivery';

export const carDeliverySlice = createSlice({
  name: 'carDelivery',
  initialState: {
    loading: false,
    error: {},
    deliveries: {},
  },
  reducers: {
    clearCarDeliveryError: (state) => {
      state.error = true;
    },
  },
  extraReducers: {
    [getAllCarDelivery.pending]: (state) => {
      state.loading = true;
    },
    [getAllCarDelivery.fulfilled]: (state, action) => {
      state.loading = false;
      state.deliveries = action.payload;
      state.error = {};
    },
    [getAllCarDelivery.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },
  },
});
export const { clearCarDeliveryError } = carDeliverySlice.actions;

export default carDeliverySlice.reducer;
